"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContextStockContainerWillCallSettingsToJSON = exports.AppContextStockContainerWillCallSettingsFromJSONTyped = exports.AppContextStockContainerWillCallSettingsFromJSON = exports.instanceOfAppContextStockContainerWillCallSettings = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AppContextStockContainerWillCallSettings interface.
 */
function instanceOfAppContextStockContainerWillCallSettings(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAppContextStockContainerWillCallSettings = instanceOfAppContextStockContainerWillCallSettings;
function AppContextStockContainerWillCallSettingsFromJSON(json) {
    return AppContextStockContainerWillCallSettingsFromJSONTyped(json, false);
}
exports.AppContextStockContainerWillCallSettingsFromJSON = AppContextStockContainerWillCallSettingsFromJSON;
function AppContextStockContainerWillCallSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'stockContainerId': !(0, runtime_1.exists)(json, 'stockContainerId') ? undefined : json['stockContainerId'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'address': !(0, runtime_1.exists)(json, 'address') ? undefined : json['address'],
        'postalCode': !(0, runtime_1.exists)(json, 'postalCode') ? undefined : json['postalCode'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'stateProvinceCode': !(0, runtime_1.exists)(json, 'stateProvinceCode') ? undefined : json['stateProvinceCode'],
        'countryCode': !(0, runtime_1.exists)(json, 'countryCode') ? undefined : json['countryCode'],
        'instructions': !(0, runtime_1.exists)(json, 'instructions') ? undefined : json['instructions'],
        'openTime': !(0, runtime_1.exists)(json, 'openTime') ? undefined : json['openTime'],
        'closeTime': !(0, runtime_1.exists)(json, 'closeTime') ? undefined : json['closeTime'],
    };
}
exports.AppContextStockContainerWillCallSettingsFromJSONTyped = AppContextStockContainerWillCallSettingsFromJSONTyped;
function AppContextStockContainerWillCallSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'stockContainerId': value.stockContainerId,
        'enabled': value.enabled,
        'name': value.name,
        'address': value.address,
        'postalCode': value.postalCode,
        'city': value.city,
        'stateProvinceCode': value.stateProvinceCode,
        'countryCode': value.countryCode,
        'instructions': value.instructions,
        'openTime': value.openTime,
        'closeTime': value.closeTime,
    };
}
exports.AppContextStockContainerWillCallSettingsToJSON = AppContextStockContainerWillCallSettingsToJSON;
